const timeZones = Intl.supportedValuesOf('timeZone').filter(
    (tz) => tz.startsWith('America/') || tz.startsWith('Pacific/')
);

export default timeZones;
